import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Grid, Tooltip, Typography, Box, CircularProgress } from '@mui/material'
import { deleteUser, usersList } from '../../utils/templatesApi'
import { toast } from 'react-toastify'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination'

export default function CustomizedTables ({ refresh, handleOpen }) {
  const [userList, setUserList] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [totalCount, setTotalCount] = React.useState(0)
  const [page, setPage] = React.useState(0)
  const [loading, setLoading] = React.useState(false)

  const handleChangePage = (event, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0) // reset to first page on rows change
  }

  const navigate = useNavigate()

  React.useEffect(() => {
    getUsersList()
  }, [refresh, rowsPerPage, page])

  const getUsersList = async () => {
    try {
      setLoading(true)
      const limit = rowsPerPage
      const resposne = await usersList(page, limit)
      setUserList(resposne?.data)
      setTotalCount(resposne.meta.totalItems)
      setLoading(false)
    } catch (error) {
      toast.error('Error in fetching users list')
      setLoading(false)
    }
  }

  const handleDelete = async id => {
    try {
      setLoading(true)
      const response = await deleteUser(id)
      if (response.success) {
        toast.success('User Deleted Successfully')

        if (userList.length === 1 && page > 0) {
          setPage(prev => prev - 1) // Move to previous page
        } else {
          getUsersList() // Just refresh current page
        }
      } else {
        toast.error('Error in deleting the user')
      }
      setLoading(false)
    } catch (error) {
      console.error('Error deleting user:', error)
      toast.error('Failed to delete user')
      setLoading(false)
    }
  }

  const handleUpdate = id => {
    navigate(`/users/${id}`)
    handleOpen()
  }
  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer
            sx={{
              mt: 2,
              minWidth: '80vw',
              maxHeight: ' 70vh',
              overflow: 'auto',
            }}
          >
            <Table aria-label='customized table'>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: '#111827',
                    position: 'sticky',
                    top: 0,
                  }}
                >
                  <TableCell sx={{ color: 'white' }}>First Name</TableCell>
                  <TableCell sx={{ color: 'white' }}>Last Name</TableCell>
                  <TableCell sx={{ color: 'white' }}>Email</TableCell>
                  <TableCell sx={{ color: 'white' }}>Role</TableCell>
                  <TableCell sx={{ color: 'white', textAlign: 'right' }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userList?.length > 0 ? (
                  userList.map(user => (
                    <TableRow key={user.id}>
                      <TableCell>{user.first_name}</TableCell>
                      <TableCell>{user.last_name}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.role}</TableCell>
                      <TableCell sx={{ cursor: 'pointer' }}>
                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                          <Tooltip title='Edit'>
                            <Grid onClick={() => handleUpdate(user.id)}>
                              <EditIcon
                                sx={{ cursor: 'pointer', color: '#1976d2' }}
                              />
                            </Grid>
                          </Tooltip>
                          <Tooltip title='Delete'>
                            <Grid onClick={() => handleDelete(user.id)}>
                              <DeleteIcon
                                sx={{ cursor: 'pointer', color: '#e53935' }}
                              />
                            </Grid>
                          </Tooltip>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                      <Typography textAlign={'center'}>
                        {' '}
                        "there is no user found"
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component='div'
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </>
  )
}
